<!-- Example for client, how to redirect deeplink -->
<template>
  <div id="box">
    <div class="inner">
      <div class="scrollWrapper">
        <div class="expandWrapper dataLoading">
          <img
            v-svg-inline
            class="img loading"
            src="../assets/imgs/loadingWhite.svg"
            alt="loading"
          />
        </div>
      </div>
      <CustomButton
        :buttonType="'accent'"
        :customButtonTxt="$t('customButton.reload')"
        @submit="reload"
      />
    </div>
  </div>
</template>

<script>
import CustomButton from "../components/customButton.vue";
export default {
  name: "Checking",
  components: {
    CustomButton,
  },
  data() {
    return {
      page: "Checking",
    };
  },
  methods: {
    reload() {
      this.$emit("reload");
    },
  },
};
</script>

<style lang="sass" scoped>
#box
  .expandWrapper.dataLoading
    +flex()
  .wrapper
    margin-top: 12px
    +flex(space-between, center, row)
</style>